import type { CapturedNetworkRequest } from "posthog-js";
import { PRIVATE_REFERENCE_URL_PARAMS, scrubUrlParams } from "./url-param-scrubber";

/**
 * `session_recording.maskCapturedNetworkRequestFn` for posthog-js.
 *
 * posthog-js routes every URL a replay records through this hook: the page URL
 * in rrweb meta events, `$url_changed` and `$pageview` replay events, and each
 * captured network or performance entry (`name` is the request URL). It is the
 * only place replay URLs can be scrubbed; the `before_send` filter never sees
 * replay snapshot data.
 *
 * Supplying this hook replaces posthog-js's built-in request/response body
 * scrubber, so bodies are always dropped here. Body capture is off for this
 * project; enabling it needs a deliberate change to this function.
 */
export function maskReplayNetworkRequest(
  request: CapturedNetworkRequest
): CapturedNetworkRequest | null | undefined {
  if (!request) return request;

  const masked: CapturedNetworkRequest = {
    ...request,
    name: request.name ? scrubUrlParams(request.name, PRIVATE_REFERENCE_URL_PARAMS) : request.name,
  };
  delete masked.requestBody;
  delete masked.responseBody;
  return masked;
}
